






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule, AppTheme } from '@/store/modules/app';

@Component({
  name: 'ThemeSelect',
})
export default class ThemeSelect extends Vue {
  public static themeSelectedEvent = 'theme-selected';

  @Prop({ default: false }) private isMobile!: boolean;

  private items = [
    {
      value: AppTheme.Light as string,
      icon: 'mdi-weather-sunny',
    },
    {
      value: AppTheme.Dark as string,
      icon: 'mdi-weather-night',
    },
  ];

  private mobileListModel = false;

  get theme() {
    return AppModule.theme;
  }

  private handleSetTheme(theme: string, emitEvent: boolean = true) {
    if (theme === (AppTheme.Light as string)) {
      this.$vuetify.theme.dark = false;
    } else if (theme === (AppTheme.Dark as string)) {
      this.$vuetify.theme.dark = true;
    } else {
      // TODO: implement another themes
      return;
    }
    AppModule.SetTheme(theme as AppTheme);

    if (emitEvent) {
      this.$emit(ThemeSelect.themeSelectedEvent, theme);
    }
  }

  private handleMobileSetTheme(theme: string) {
    this.handleSetTheme(theme, false);
    this.mobileListModel = false;
    this.$emit(ThemeSelect.themeSelectedEvent, theme);
  }
}
